import { EnemyBipedSkinType, SpineDataName } from "../../../spine-config/spine-config"
import { VariantAI } from "../ai-types"
import { ENEMY_NAME } from "../enemy-names"

export const skeletonMage2: VariantAI = {
    extends: ENEMY_NAME.SKELETON_MAGE_1,
    name: ENEMY_NAME.SKELETON_MAGE_2,
    appearance: {
        asset: SpineDataName.SKELETON_MAGE_2,
        spriteSheet: true,
        skin: EnemyBipedSkinType.DEFAULT,
    },
}

export const skeletonMage3: VariantAI = {
    extends: ENEMY_NAME.SKELETON_MAGE_1,
    name: ENEMY_NAME.SKELETON_MAGE_3,
    appearance: {
        asset: SpineDataName.SKELETON_MAGE_3,
        spriteSheet: true,
        skin: EnemyBipedSkinType.DEFAULT,
    },
}